import { get } from 'lodash'
import React from 'react'
import styled from 'styled-components'
import moment from 'moment'

import {
  Input,
  TextArea,
  CustomSearchSelect,
  SearchSelect,
} from '../../../../../input'
import { CustomDatePicker } from '../../../../../datepicker'
import { FONTS } from '../../../../../../constants'
import { getExcludeVat, getVat, getIncludeVat } from '../../../../../../function/billing'
import { vatOptions, status } from '../../../../constants'

export const BillingDetail = ({ data, billing, targetBilling, handleInput }) => {
  const _status = status.find(s => s.value === data.status) || null
  // const _vat = targetBilling ? (targetBilling.vat || 0) : 0
  const _vat = data.vat ? vatOptions.find(v => v.value === data.vat) : null
  const invoiceDate = targetBilling ? (moment(targetBilling.invoice_date).format('DD/MM/YYYY') || '-') : '-'
  const billingName = get(targetBilling, 'name', '-')
  const billingId = get(targetBilling, 'billing_no', '-')
  const excludeVat = getExcludeVat(targetBilling)
  const vat = getVat(targetBilling)
  const include = getIncludeVat(targetBilling)
  const updateBy = data ? data.update_by : null
  const updated = data ? moment(data.updated).format('DD/MM/YYYY') : null

  return (
    <React.Fragment>
      <FlexRow>
        <FlexCol flex={ 1 }>
          <Title>Project Code</Title>
          <AlignCenterWrapper>
            <Text>{ billing.project_code || '-' }</Text>
          </AlignCenterWrapper>
        </FlexCol>
        <FlexCol flex={ 3 } margin='0 12px'>
          <Title>Description</Title>
          <AlignCenterWrapper>{ billing.project_name || '-' }</AlignCenterWrapper>
        </FlexCol>
        <FlexCol flex={ 1 }>
          <Title>LOB</Title>
          <AlignCenterWrapper>{ billing.lob_name || '-' }</AlignCenterWrapper>
        </FlexCol>
      </FlexRow>
      <FlexRow>
        <FlexCol flex={ 2 }>
          <Title>Milestone</Title>
          <AlignCenterWrapper>
            <Text>{billingId}</Text>
          </AlignCenterWrapper>
        </FlexCol>
        <FlexCol flex={ 5 } margin='0 12px'>
          <Title>Process Description</Title>
          <AlignCenterWrapper>{billingName}</AlignCenterWrapper>
        </FlexCol>
        <FlexCol flex={ 2 }>
          <Title>Plan Invoice Date</Title>
          <AlignCenterWrapper>
            <Text>{invoiceDate}</Text>
          </AlignCenterWrapper>
        </FlexCol>
        <DateCol flex={ 3 }>
          <Title>Revised Invoice Date</Title>
          <CustomDatePicker
            autoComplete='off'
            dateFormat='DD/MM/YYYY'
            selected={ data.revised_invoice_date ? moment(data.revised_invoice_date) : null }
            onChange={ e => handleInput(e, 'revised_invoice_date') }
          />
        </DateCol>
      </FlexRow>
      <FlexRow>
        <VatWrapper>
          <FlexEndCol flex={ 1 }>
            <Title>Exc. Vat</Title>
            <Number>฿​ {excludeVat}</Number>
          </FlexEndCol>
          <FlexEndCol flex={ 2 } center>
            <Title>VAT</Title>
            <VatRow>
              <Number>฿ ​{vat}</Number>
              <VatDropdown>
                <SearchSelect
                  placeholder='Select Vat'
                  options={ vatOptions }
                  value={ _vat }
                  onChange={ e => handleInput(e.value, 'vat') }
                />
              </VatDropdown>
            </VatRow>
            {/* <VatRow>
              <Number>฿ ​{vat}</Number>&nbsp;
              <Text>({_vat}%)</Text>
            </VatRow> */}
          </FlexEndCol>
          <FlexEndCol flex={ 1 }>
            <Title>Inc. VAT</Title>
            <Number>฿ ​{include}</Number>
          </FlexEndCol>
        </VatWrapper>
      </FlexRow>
      <FlexRow>
        <Title>PM’s remark:</Title>&nbsp;
        <RemarkWrapper>
          <RemarkText>{ data.pm_remark }</RemarkText>
        </RemarkWrapper>
      </FlexRow>
      <FlexRow>
        <Title>Last Updated:</Title>&nbsp;
        <AlignCenterWrapper>{ `${updated} ${updateBy}` }</AlignCenterWrapper>
        {/* <AlignCenterWrapper>26/11/2019 Natdanai Umrachod (Ong)</AlignCenterWrapper> */}
      </FlexRow>
      <HeaderText>AR Billing Entry</HeaderText>
      <FlexRow>
        <NoBorderCol flex={ 1 } margin='0 12px 0 0'>
          <EntryTitle>Status</EntryTitle>
          <CustomSearchSelect
            placeholder='Select Status'
            options={ status }
            value={ _status }
            onChange={ e => handleInput(e.value, 'status') }
          />
        </NoBorderCol>
        <NoBorderCol flex={ 1 }>
          <EntryTitle>Actual Invoice Date</EntryTitle>
          <CustomDatePicker
            autoComplete='off'
            dateFormat='DD/MM/YYYY'
            selected={ data.actual_invoice_date ? moment(data.actual_invoice_date) : null }
            onChange={ e => handleInput(e, 'actual_invoice_date') }
          />
        </NoBorderCol>
        <NoBorderCol flex={ 3 } margin='0 12px'>
          <EntryTitle>Invoice Number</EntryTitle>
          <Input
            placeholder='Enter Invoice Number'
            value={ data.invoice_number || '' }
            onChange={ e => handleInput(e.target.value, 'invoice_number') }
          />
        </NoBorderCol>
        <NoBorderCol flex={ 1 }>
          <EntryTitle>Cash Received Date</EntryTitle>
          <CustomDatePicker
            autoComplete='off'
            dateFormat='DD/MM/YYYY'
            selected={ data.cash_receive_date ? moment(data.cash_receive_date) : null }
            onChange={ e => handleInput(e, 'cash_receive_date') }
          />
        </NoBorderCol>
      </FlexRow>
      <FlexRow>
        <NoBorderCol flex={ 1 }>
          <EntryTitle>Remark</EntryTitle>
          <TextArea
            placeholder='Enter Remark'
            value={ data.remark || '' }
            onChange={ e => handleInput(e.target.value, 'remark') }
          />
        </NoBorderCol>
      </FlexRow>
    </React.Fragment>
  )
}

const Row = styled.div`
  display: flex;
`

const FlexRow = styled(Row)`
  margin-bottom: 12px;
  ${p => p.flex && `flex: ${p.flex}`}
`

const Col = styled.div`
  display: flex;
  flex-direction: column;
`

const FlexCol = styled(Col)`
  margin: ${p => p.margin};
  ${p => p.flex && `flex: ${p.flex}`}
  background: #F9F9F9;
  border: 1px solid #F1F1F1;
  border-radius: 4px;
  padding: 8px 12px;
`

const NoBorderCol = styled(FlexCol)`
  background: transparent;
  border: none;
  padding: 0;
`

const DateCol = styled(NoBorderCol)`
  padding-left: 12px;
`

const PriceWrapper = styled(Row)`
  align-items: center;
  flex: 2;
  padding: 10px 16px;
  background: #F9F9F9;
  border-radius: 4px;
`

const VatWrapper = styled(PriceWrapper)`
  height: 58px;
  flex: 4;
  border: 1px solid #F1F1F1;
`

const FlexEndCol = styled(Col)`
  align-items: ${p => (p.center ? 'center' : 'flex-end')};
  ${p => p.flex && `flex: ${p.flex}`}
  padding: 8px 12px;
`

const Title = styled.span`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.SMALL_SIZE};
  color: #808080;
`

const EntryTitle = styled(Title)`
  color: #333333;
`

const VatRow = styled.div`
  display: flex;
  align-items: center;
`

const Number = styled.span`
  font-family: ${FONTS.NOTOSANS_MEDIUM};
  font-size: ${FONTS.NORMAL_SIZE};
  color: #1A1A17;
`

const AlignCenterWrapper = styled(Row)`
  height: 100%;
  align-items: center;
`

const RemarkWrapper = styled(AlignCenterWrapper)`
  flex: 1;
`

const Text = styled.span`
  font-family: ${FONTS.NOTOSANS};
  font-size: ${FONTS.NORMAL_SIZE};
  color: #1A1A17;
`

const HeaderText = styled.span`
  font-family: ${FONTS.GOTHAM_BOLD};
  font-size: ${FONTS.TITLE_SIZE};
  color: #333333;
  margin-bottom: 8px;
`

const VatDropdown = styled.div`
  width: 70px;
  margin-left: 8px;
`

const RemarkText = styled.span`
  word-break: break-all;
`



// WEBPACK FOOTER //
// ./src/components/accounting-dashboard/data-table/ar-billing/edit-billing/billing-detail/index.js